import { render, staticRenderFns } from "./videos_table.vue?vue&type=template&id=1ab76121&scoped=true&"
import script from "./videos_table.vue?vue&type=script&lang=js&"
export * from "./videos_table.vue?vue&type=script&lang=js&"
import style0 from "./videos_table.vue?vue&type=style&index=0&id=1ab76121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab76121",
  null
  
)

export default component.exports